import { Icon } from "@circle-react/components/shared/Icon";

export const CloseButton = ({
  onClick,
  ariaLabel,
}: {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  ariaLabel: string;
}) => (
  <button
    type="button"
    className="focus-visible:!outline-secondary p-[0.3562rem] leading-[1.188rem]"
    onClick={onClick}
    aria-label={ariaLabel}
  >
    <Icon
      type="20-close-sm"
      aria-hidden
      size={20}
      className="text-light hover:text-dark"
    />
  </button>
);
